import styled from 'styled-components';

import POIVenuesList from './POIVenuesList';

export default styled(POIVenuesList)`
  overflow: hidden;
  overflow-y: auto;
  flex: 1;

  .venue-item {
    padding: 1.6rem;
    border-bottom: 1px solid var(--grey200);
    cursor: pointer;
    &.selected {
      background-color: var(--grey100);
    }
  }

  .venue-name {
    color: var(--grey800);
    font-size: 1.6rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .venue-address {
    color: var(--grey700);
    font-size: 1.4rem;
  }
`;
